<style>
@import '../../custom/css/lista-dicas.css';

#clientes .limit-table::-webkit-scrollbar:vertical {
  display: none;
}
</style>

<template>
  <div class="mt-4">
    <h1 class="title text-uppercase font-weight-bold">Versões do App</h1>

    <hr class="linha-amarela" />

    <table class="table">
      <thead class="letter-orange">
        <tr>
          <th>Código da loja</th>
          <th>Build</th>
          <th>Build bloqueio</th>
          <th>Link Android</th>
          <th>Link Apple</th>
          <th>Opções</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in data" :key="index">
          <td>{{ item.construp_user_id }}</td>
          <td>{{ item.version }}</td>
          <td>{{ item.version_block }}</td>
          <td>{{ formatUrl(item.link_android) }}</td>
          <td>{{ formatUrl(item.link_apple) }}</td>
          <td>
            <div class="btn btn-primary" @click="editarServer(item)">
              <i class="fas fa-edit"></i>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <b-modal
        title="Atualizar versão"
        size="xl"
        id="versionModal"
        header-bg-variant="orange"
        header-text-variant="light"
        centered
        hide-header
        hide-footer>
      
      <div class="row">
        <div class="col-4">
          <label>Id Lojista</label>
          <input type="text" class="form-control" v-model="loja.construp_user_id" disabled>
        </div>

        <div class="col-4">
          <label>Build</label>
          <input type="number" class="form-control" v-model="loja.version" placeholder="##">
        </div>

        <div class="col-4">
          <label>Build bloqueio</label>
          <input type="number" class="form-control" v-model="loja.version_block" placeholder="##">
        </div>

        <div class="col-12 mt-2">
          <label>Link Android</label>
          <input type="text" class="form-control" v-model="loja.link_android">
        </div>

        <div class="col-12 mt-2">
          <label>Link Apple</label>
          <input type="text" class="form-control" v-model="loja.link_apple"> 
        </div>

        <div class="col-12 mt-2">
          <label>Link para identificar o tipo do SmartPhone</label>
          <input type="text" class="form-control" :value="montarUrl(loja.construp_user_id)" readonly> 
        </div>

        <div class="col-12 mt-4">
          <h6 class="text-center"> <b>QrCode para lojas</b></h6>
        </div>

        <div class="col-6 mt-2 text-center" download id="canvas">
          <span class="">Google</span>
          <qrcode-vue 
            class="mt-2"
            :value="loja.link_android" 
            size="120" 
            level="H" 
          />
        </div>

        <div class="col-6 mt-2 text-center">
          <span>Apple</span>
          <qrcode-vue 
            class="mt-2"
            :value="loja.link_apple" 
            size="120" 
            level="H" 
          />
        </div>

        <div class="col-12">
          <button class="btn btn-success btn-block mt-4" @click="salvar()">Salvar</button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import makeToast from "../../mixins/makeToast";
import QrcodeVue from 'qrcode.vue';

export default {
  name: 'AppVersion',
  mixins: [makeToast],

  data() {
    return {
      data: [],
      loja: []
    }
  },

  components: {
    QrcodeVue,
  },

  computed: {
    ...mapState(['token', 'dadosUsuario']),
  },

  created() {
    this.buscarLojistas();
  },

  methods: {
    formatUrl(url) {
      if(url != null && url != '') {
        return url.substr(0, 20);  
      }

      return '';
    },
    montarUrl(id){
      const base64Id = btoa(id);
      return process.env.VUE_APP_CURRENT_SITE_ADDRESS+'/link-app/'+base64Id;
    },
    buscarLojistas() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('admin/buscarVersion')
        .then((response) => {
          this.data = response.data
        })
        .catch(() => {
          this.makeToast('Erro', 'Erro ao buscar dados!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        })
    },
    salvar() {
      const data = {
        id: this.loja.construp_user_id,
        version: this.loja.version,
        version_block: this.loja.version_block,
        link_android: this.loja.link_android,
        link_apple: this.loja.link_apple
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('admin/saveVersion', data)
        .then(() => {
          this.$bvModal.hide('versionModal');
          this.makeToast('sucesso', 'Versão atualizada!', 'success');
          this.buscarLojistas();
        })
        .catch(() => {
          this.makeToast('Erro', 'Erro ao atualizar dados!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        })
    },
    editarServer(item) {
      this.loja = item;
      this.$bvModal.show('versionModal');
    }
  },
};
</script>
